export const RECORDER_MAX_GRID_SIZE = 4;
export const RECORDER_MAX_GRID_SIZE_WITH_SCREENSCHARE_ENABLED = 4;

export const meetingModes = {
  VIEWER: "VIEWER",
  CONFERENCE: "CONFERENCE",
};
